/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ReportApiConfiguration configuration object with a given root URL.
 */
export function provideReportApiConfiguration(rootUrl: string) {
  var config = new ReportApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ReportApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ReportApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `ReportModule.forRoot()`
 */
export interface ReportApiConfigurationParams {
  rootUrl?: string;
}
